const object = require('../../define/object').default;
// =============================
// define:
const SCENARIO_TUTORIAL = "@TUTORIAL"
const SCENARIO_OPENING = "@OPENING"
const SCENARIO_BEAST = "@BEAST"
const SCENARIO_WITCH = "@WITCH"
const SCENARIO_START = "@START"
const SCENARIO_FINAL = "@FINAL"
const SCENARIO_ENDING = "@ENDING"
export const stageScenario = {
    SCENARIO_TUTORIAL,
    SCENARIO_OPENING,
    SCENARIO_BEAST,
    SCENARIO_WITCH,
    SCENARIO_START,
    SCENARIO_FINAL,
    SCENARIO_ENDING
}

const GIMMICK_BEAST = "@GIM_BEAST"
export const stageGimmick = {
    GIMMICK_BEAST
}

const ELVIRA = {
    object: object.OBJ_MOB_ELVIRA,
    hp: 4,
    bonus: 10
};
const RUDO = {
    object: object.OBJ_MOB_RUDO,
    hp: 8,
    bonus: 15
};
const SEOHYUN = {
    object: object.OBJ_MOB_SEOHYUN,
    hp: 24,
    bonus: 30
};
const LOLA = {
    object: object.OBJ_MOB_LOLA,
    hp: 30,
    bonus: 50
};
const ZILANT = {
    object: object.OBJ_MOB_ZILANT,
    hp: 100,
    bonus: 1000
};
const GARM = {
    object: object.OBJ_MOB_GARM,
    hp: 24,
    bonus: 100,
    weakness: object.OBJ_BOM_RED
};
const NIGHTMARE = {
    object: object.OBJ_MOB_NIGHTMARE,
    hp: 24,
    bonus: 100,
    weakness: object.OBJ_BOM_BLUE
};
const GRYPHON = {
    object: object.OBJ_MOB_GRYPHON,
    hp: 24,
    bonus: 100,
    weakness: object.OBJ_BOM_GREEN
}

const TREASURE = {
    object: object.OBJ_TREASURE,
    hp: 1,
    bonus: 100
}

const IMMORTAL_GATE = {
    object: object.OBJ_IMMORTAL_GATE,
    hp: 1,
    bonus: 0
};
const IMMORTAL_POLE = {
    object: object.OBJ_IMMORTAL_POLE,
    hp: 1,
    bonus: 0
};
const IMMORTAL_CLYSTAL = {
    object: object.OBJ_IMMORTAL_CLYSTAL,
    hp: 1,
    bonus: 0
};
const IMMORTAL_TABLE = {
    object: object.OBJ_IMMORTAL_TABLE,
    hp: 1,
    bonus: 0
};
const IMMORTAL_BED = {
    object: object.OBJ_IMMORTAL_BED,
    hp: 1,
    bonus: 0
};
const IMMORTAL_TOMB = {
    object: object.OBJ_IMMORTAL_TOMB,
    hp: 1,
    bonus: 0
};

const stageDataArray = [
    { name: "", bonus: 0, map: [] },
    {
        name: "愚者の城門",
        bonus: 100,
        start: SCENARIO_TUTORIAL,
        clear: SCENARIO_START,
        map: [
            { posX: 1, posY: 5, ...ELVIRA },
            { posX: 3, posY: 5, ...ELVIRA },
            { posX: 5, posY: 5, ...ELVIRA },
            { posX: 3, posY: 2, ...RUDO },
            { posX: 1, posY: 1, ...TREASURE },
            { posX: 1, posY: 0, ...IMMORTAL_GATE },
            { posX: 2, posY: 0, ...IMMORTAL_GATE },
            { posX: 3, posY: 0, ...IMMORTAL_GATE },
            { posX: 4, posY: 0, ...IMMORTAL_GATE },
            { posX: 5, posY: 0, ...IMMORTAL_GATE },
            { posX: 6, posY: 0, ...IMMORTAL_GATE },
        ]
    },
    {
        name: "世界の小部屋",
        bonus: 100,
        start: SCENARIO_OPENING,
        map: [
            { posX: 3, posY: 1, ...ELVIRA },
            { posX: 4, posY: 1, ...ELVIRA },
            { posX: 3, posY: 2, ...RUDO },
            { posX: 4, posY: 2, ...RUDO },
            { posX: 0, posY: 2, ...TREASURE },
            { posX: 0, posY: 1, ...IMMORTAL_POLE },
            { posX: 0, posY: 3, ...IMMORTAL_POLE },
            { posX: 0, posY: 5, ...IMMORTAL_POLE },
            { posX: 7, posY: 1, ...IMMORTAL_POLE },
            { posX: 7, posY: 3, ...IMMORTAL_POLE },
            { posX: 7, posY: 5, ...IMMORTAL_POLE },
        ]
    },
    {
        name: "審判の部屋",
        bonus: 100,
        map: [
            { posX: 1, posY: 1, ...ELVIRA },
            { posX: 1, posY: 2, ...ELVIRA },
            { posX: 2, posY: 7, ...ELVIRA },
            { posX: 6, posY: 1, ...RUDO },
            { posX: 6, posY: 2, ...RUDO },
            { posX: 5, posY: 7, ...RUDO },
            { posX: 6, posY: 0, ...TREASURE },
            { posX: 2, posY: 0, ...IMMORTAL_POLE },
            { posX: 5, posY: 0, ...IMMORTAL_POLE },
        ]
    },
    {
        name: "太陽の通路",
        bonus: 100,
        map: [
            { posX: 3, posY: 1, ...ELVIRA },
            { posX: 4, posY: 1, ...LOLA },
            { posX: 6, posY: 4, ...TREASURE },
            { posX: 1, posY: 1, ...IMMORTAL_POLE },
            { posX: 1, posY: 2, ...IMMORTAL_POLE },
            { posX: 6, posY: 1, ...IMMORTAL_POLE },
            { posX: 6, posY: 2, ...IMMORTAL_POLE },
            { posX: 1, posY: 5, ...IMMORTAL_POLE },
            { posX: 2, posY: 6, ...IMMORTAL_POLE },
            { posX: 5, posY: 6, ...IMMORTAL_POLE },
            { posX: 6, posY: 5, ...IMMORTAL_POLE }
        ]
    },
    {
        name: "祈りの間",
        bonus: 100,
        start: SCENARIO_BEAST,
        map: [
            { posX: 3, posY: 4, ...NIGHTMARE },
            { posX: 4, posY: 3, ...TREASURE },
            { posX: 1, posY: 1, ...IMMORTAL_CLYSTAL },
            { posX: 1, posY: 2, ...IMMORTAL_CLYSTAL },
            { posX: 1, posY: 6, ...IMMORTAL_CLYSTAL },
            { posX: 2, posY: 6, ...IMMORTAL_CLYSTAL },
            { posX: 5, posY: 1, ...IMMORTAL_CLYSTAL },
            { posX: 6, posY: 1, ...IMMORTAL_CLYSTAL },
            { posX: 6, posY: 5, ...IMMORTAL_CLYSTAL },
            { posX: 6, posY: 6, ...IMMORTAL_CLYSTAL }
        ]
    },
    {
        name: "月の部屋",
        bonus: 200,
        map: [
            { posX: 7, posY: 0, ...SEOHYUN },
            { posX: 0, posY: 7, ...SEOHYUN },
            { posX: 1, posY: 0, ...TREASURE },
            { posX: 1, posY: 1, ...IMMORTAL_BED },
            { posX: 1, posY: 4, ...IMMORTAL_BED },
            { posX: 3, posY: 1, ...IMMORTAL_BED },
            { posX: 6, posY: 4, ...IMMORTAL_BED },
        ]
    },
    {
        name: "星の塔",
        bonus: 200,
        map: [
            { posX: 1, posY: 0, ...ELVIRA },
            { posX: 4, posY: 0, ...ELVIRA },
            { posX: 1, posY: 3, ...ELVIRA },
            { posX: 4, posY: 3, ...ELVIRA },
            { posX: 7, posY: 3, ...ELVIRA },
            { posX: 4, posY: 6, ...ELVIRA },
            { posX: 7, posY: 6, ...ELVIRA },
            { posX: 1, posY: 6, ...TREASURE },
            { posX: 6, posY: 1, ...IMMORTAL_POLE },
            { posX: 2, posY: 5, ...IMMORTAL_POLE }
        ]
    },
    {
        name: "塔の地下",
        bonus: 200,
        map: [
            { posX: 3, posY: 0, ...LOLA },
            { posX: 4, posY: 0, ...SEOHYUN },
            { posX: 7, posY: 0, ...TREASURE },
            { posX: 1, posY: 0, ...IMMORTAL_TABLE },
            { posX: 6, posY: 0, ...IMMORTAL_TABLE },
            { posX: 2, posY: 2, ...IMMORTAL_POLE },
            { posX: 5, posY: 2, ...IMMORTAL_POLE },
            { posX: 2, posY: 5, ...IMMORTAL_POLE },
            { posX: 5, posY: 5, ...IMMORTAL_POLE }
        ]
    },
    {
        name: "悪魔の城壁",
        bonus: 200,
        map: [
            { posX: 1, posY: 6, ...RUDO },
            { posX: 6, posY: 1, ...RUDO },
            { posX: 2, posY: 7, ...RUDO },
            { posX: 7, posY: 2, ...RUDO },
            { posX: 1, posY: 0, ...TREASURE },
            { posX: 0, posY: 0, ...IMMORTAL_POLE },
            { posX: 1, posY: 1, ...IMMORTAL_POLE },
            { posX: 2, posY: 2, ...IMMORTAL_POLE },
            { posX: 3, posY: 3, ...IMMORTAL_POLE },
            { posX: 4, posY: 4, ...IMMORTAL_POLE },
            { posX: 5, posY: 5, ...IMMORTAL_POLE },
            { posX: 6, posY: 6, ...IMMORTAL_POLE },
            { posX: 7, posY: 7, ...IMMORTAL_POLE }
        ]
    },
    {
        name: "節制の部屋",
        bonus: 200,
        map: [
            { posX: 2, posY: 3, ...ELVIRA },
            { posX: 3, posY: 3, ...ELVIRA },
            { posX: 4, posY: 3, ...ELVIRA },
            { posX: 2, posY: 4, ...ELVIRA },
            { posX: 3, posY: 4, ...ELVIRA },
            { posX: 4, posY: 4, ...ELVIRA },
            { posX: 2, posY: 5, ...ELVIRA },
            { posX: 3, posY: 5, ...ELVIRA },
            { posX: 4, posY: 5, ...ELVIRA },
            { posX: 7, posY: 5, ...TREASURE },
            { posX: 1, posY: 0, ...IMMORTAL_BED },
            { posX: 3, posY: 0, ...IMMORTAL_BED },
            { posX: 5, posY: 0, ...IMMORTAL_BED },
            { posX: 7, posY: 0, ...IMMORTAL_BED },
            { posX: 7, posY: 2, ...IMMORTAL_BED },
            { posX: 7, posY: 4, ...IMMORTAL_BED },
            { posX: 7, posY: 6, ...IMMORTAL_BED }
        ]
    },
    {
        name: "死神の墓地",
        bonus: 200,
        map: [
            { posX: 4, posY: 4, ...LOLA },
            { posX: 2, posY: 0, ...TREASURE },
            { posX: 0, posY: 1, ...IMMORTAL_TOMB },
            { posX: 2, posY: 1, ...IMMORTAL_TOMB },
            { posX: 4, posY: 1, ...IMMORTAL_GATE },
            { posX: 5, posY: 1, ...IMMORTAL_GATE },
            { posX: 6, posY: 1, ...IMMORTAL_GATE },
            { posX: 0, posY: 3, ...IMMORTAL_TOMB },
            { posX: 2, posY: 3, ...IMMORTAL_TOMB },
            { posX: 6, posY: 3, ...IMMORTAL_TOMB },
            { posX: 0, posY: 5, ...IMMORTAL_TOMB },
            { posX: 2, posY: 5, ...IMMORTAL_TOMB },
            { posX: 6, posY: 5, ...IMMORTAL_TOMB },
            { posX: 0, posY: 7, ...IMMORTAL_TOMB },
            { posX: 2, posY: 7, ...IMMORTAL_TOMB },
            { posX: 6, posY: 7, ...IMMORTAL_TOMB },
        ]
    },
    {
        name: "財の間",
        bonus: 200,
        map: [
            { posX: 3, posY: 5, ...GRYPHON },
            { posX: 0, posY: 1, ...TREASURE },
            { posX: 3, posY: 0, ...TREASURE },
            { posX: 7, posY: 0, ...TREASURE },
            { posX: 2, posY: 0, ...IMMORTAL_CLYSTAL },
            { posX: 5, posY: 0, ...IMMORTAL_CLYSTAL },
            { posX: 2, posY: 1, ...IMMORTAL_CLYSTAL },
            { posX: 5, posY: 1, ...IMMORTAL_CLYSTAL },
            { posX: 2, posY: 2, ...IMMORTAL_CLYSTAL },
            { posX: 5, posY: 2, ...IMMORTAL_CLYSTAL }
        ]
    },
    {
        name: "吊るされた男の拷問部屋",
        bonus: 300,
        map: [
            { posX: 2, posY: 3, ...ELVIRA },
            { posX: 4, posY: 1, ...RUDO },
            { posX: 5, posY: 1, ...SEOHYUN },
            { posX: 6, posY: 1, ...LOLA },
            { posX: 1, posY: 3, ...TREASURE },
            { posX: 1, posY: 2, ...IMMORTAL_GATE },
            { posX: 2, posY: 2, ...IMMORTAL_GATE },
            { posX: 3, posY: 2, ...IMMORTAL_GATE },
            { posX: 4, posY: 2, ...IMMORTAL_GATE },
            { posX: 3, posY: 3, ...IMMORTAL_POLE },
            { posX: 5, posY: 6, ...IMMORTAL_POLE },
        ]
    },
    {
        name: "正義の小部屋",
        bonus: 300,
        map: [
            { posX: 1, posY: 0, ...LOLA },
            { posX: 6, posY: 0, ...LOLA },
            { posX: 3, posY: 5, ...LOLA },
            { posX: 6, posY: 7, ...TREASURE },
            { posX: 2, posY: 2, ...IMMORTAL_POLE },
            { posX: 5, posY: 3, ...IMMORTAL_POLE },
            { posX: 1, posY: 4, ...IMMORTAL_POLE },
            { posX: 3, posY: 6, ...IMMORTAL_POLE },
            { posX: 6, posY: 6, ...IMMORTAL_POLE }
        ]
    },
    {
        name: "運命の輪の間",
        bonus: 300,
        map: [
            { posX: 5, posY: 1, ...ELVIRA },
            { posX: 6, posY: 1, ...ELVIRA },
            { posX: 7, posY: 1, ...ELVIRA },
            { posX: 5, posY: 6, ...RUDO },
            { posX: 6, posY: 6, ...RUDO },
            { posX: 7, posY: 6, ...RUDO },
            { posX: 1, posY: 6, ...TREASURE },
            { posX: 4, posY: 0, ...IMMORTAL_POLE },
            { posX: 4, posY: 1, ...IMMORTAL_POLE },
            { posX: 4, posY: 2, ...IMMORTAL_POLE },
            { posX: 4, posY: 5, ...IMMORTAL_POLE },
            { posX: 4, posY: 6, ...IMMORTAL_POLE },
            { posX: 4, posY: 7, ...IMMORTAL_POLE }
        ]
    },
    {
        name: "隠者の部屋",
        bonus: 300,
        map: [
            { posX: 3, posY: 1, ...RUDO },
            { posX: 4, posY: 1, ...RUDO },
            { posX: 3, posY: 5, ...SEOHYUN },
            { posX: 4, posY: 5, ...SEOHYUN },
            { posX: 1, posY: 3, ...TREASURE },
            { posX: 2, posY: 0, ...IMMORTAL_TABLE },
            { posX: 5, posY: 0, ...IMMORTAL_TABLE },
            { posX: 1, posY: 2, ...IMMORTAL_BED },
            { posX: 3, posY: 2, ...IMMORTAL_BED },
            { posX: 4, posY: 2, ...IMMORTAL_BED },
            { posX: 6, posY: 2, ...IMMORTAL_BED }
        ]
    },
    {
        name: "力のペコ舎",
        bonus: 300,
        map: [
            { posX: 2, posY: 0, ...LOLA },
            { posX: 3, posY: 0, ...LOLA },
            { posX: 4, posY: 0, ...SEOHYUN },
            { posX: 5, posY: 0, ...SEOHYUN },
            { posX: 2, posY: 1, ...ELVIRA },
            { posX: 3, posY: 1, ...ELVIRA },
            { posX: 4, posY: 1, ...RUDO },
            { posX: 5, posY: 1, ...RUDO },
            { posX: 2, posY: 7, ...TREASURE }
        ]
    },
    {
        name: "戦車の大広間",
        bonus: 300,
        map: [
            { posX: 3, posY: 1, ...ELVIRA },
            { posX: 4, posY: 1, ...ELVIRA },
            { posX: 3, posY: 2, ...LOLA },
            { posX: 4, posY: 2, ...LOLA },
            { posX: 1, posY: 6, ...TREASURE },
            { posX: 1, posY: 2, ...IMMORTAL_POLE },
            { posX: 6, posY: 2, ...IMMORTAL_POLE },
            { posX: 3, posY: 3, ...IMMORTAL_TABLE },
            { posX: 4, posY: 3, ...IMMORTAL_TABLE },
            { posX: 0, posY: 5, ...IMMORTAL_TOMB },
            { posX: 1, posY: 5, ...IMMORTAL_TOMB },
            { posX: 2, posY: 5, ...IMMORTAL_TOMB },
            { posX: 5, posY: 5, ...IMMORTAL_TOMB },
            { posX: 6, posY: 5, ...IMMORTAL_TOMB },
            { posX: 7, posY: 5, ...IMMORTAL_TOMB },
            { posX: 0, posY: 7, ...IMMORTAL_TOMB },
            { posX: 1, posY: 7, ...IMMORTAL_TOMB },
            { posX: 2, posY: 7, ...IMMORTAL_TOMB },
            { posX: 5, posY: 7, ...IMMORTAL_TOMB },
            { posX: 6, posY: 7, ...IMMORTAL_TOMB },
            { posX: 7, posY: 7, ...IMMORTAL_TOMB }
        ]
    },
    {
        name: "恋人の教会",
        bonus: 300,
        map: [
            { posX: 2, posY: 2, ...LOLA },
            { posX: 5, posY: 5, ...SEOHYUN },
            { posX: 0, posY: 4, ...TREASURE },
            { posX: 2, posY: 0, ...IMMORTAL_POLE },
            { posX: 2, posY: 1, ...IMMORTAL_POLE },
            { posX: 0, posY: 2, ...IMMORTAL_POLE },
            { posX: 1, posY: 2, ...IMMORTAL_POLE },
            { posX: 6, posY: 5, ...IMMORTAL_POLE },
            { posX: 7, posY: 5, ...IMMORTAL_POLE },
            { posX: 5, posY: 6, ...IMMORTAL_POLE },
            { posX: 5, posY: 7, ...IMMORTAL_POLE }
        ]
    },
    {
        name: "法王の部屋",
        bonus: 300,
        map: [
            { posX: 3, posY: 2, ...RUDO },
            { posX: 4, posY: 2, ...RUDO },
            { posX: 5, posY: 5, ...RUDO },
            { posX: 6, posY: 5, ...SEOHYUN },
            { posX: 7, posY: 5, ...RUDO },
            { posX: 7, posY: 0, ...TREASURE },
            { posX: 2, posY: 1, ...IMMORTAL_POLE },
            { posX: 3, posY: 1, ...IMMORTAL_POLE },
            { posX: 4, posY: 1, ...IMMORTAL_POLE },
            { posX: 5, posY: 1, ...IMMORTAL_POLE },
            { posX: 6, posY: 1, ...IMMORTAL_POLE },
            { posX: 7, posY: 1, ...IMMORTAL_POLE },
            { posX: 2, posY: 5, ...IMMORTAL_TABLE },
            { posX: 5, posY: 4, ...IMMORTAL_BED },
            { posX: 7, posY: 4, ...IMMORTAL_BED },
            { posX: 5, posY: 6, ...IMMORTAL_BED },
            { posX: 7, posY: 6, ...IMMORTAL_BED }
        ]
    },
    {
        name: "宝物庫",
        bonus: 300,
        map: [
            { posX: 1, posY: 1, ...GARM },
            { posX: 5, posY: 0, ...TREASURE },
            { posX: 6, posY: 1, ...TREASURE },
            { posX: 7, posY: 2, ...TREASURE },
            { posX: 0, posY: 5, ...TREASURE },
            { posX: 1, posY: 6, ...TREASURE },
            { posX: 2, posY: 7, ...TREASURE },
            { posX: 3, posY: 0, ...IMMORTAL_CLYSTAL },
            { posX: 4, posY: 1, ...IMMORTAL_CLYSTAL },
            { posX: 5, posY: 2, ...IMMORTAL_CLYSTAL },
            { posX: 6, posY: 3, ...IMMORTAL_CLYSTAL },
            { posX: 7, posY: 4, ...IMMORTAL_CLYSTAL },
            { posX: 0, posY: 3, ...IMMORTAL_CLYSTAL },
            { posX: 1, posY: 4, ...IMMORTAL_CLYSTAL },
            { posX: 2, posY: 5, ...IMMORTAL_CLYSTAL },
            { posX: 3, posY: 6, ...IMMORTAL_CLYSTAL },
            { posX: 4, posY: 7, ...IMMORTAL_CLYSTAL }
        ]
    },
    {
        name: "皇帝の祭壇",
        bonus: 400,
        map: [
            { posX: 3, posY: 2, ...SEOHYUN },
            { posX: 4, posY: 2, ...LOLA },
            { posX: 3, posY: 3, ...RUDO },
            { posX: 4, posY: 3, ...ELVIRA },
            { posX: 5, posY: 2, ...TREASURE },
            { posX: 2, posY: 1, ...IMMORTAL_POLE },
            { posX: 5, posY: 1, ...IMMORTAL_POLE },
            { posX: 1, posY: 3, ...IMMORTAL_GATE },
            { posX: 2, posY: 3, ...IMMORTAL_GATE },
            { posX: 5, posY: 3, ...IMMORTAL_GATE },
            { posX: 6, posY: 3, ...IMMORTAL_GATE },
            { posX: 2, posY: 5, ...IMMORTAL_POLE },
            { posX: 5, posY: 5, ...IMMORTAL_POLE },
            { posX: 2, posY: 7, ...IMMORTAL_POLE },
            { posX: 5, posY: 7, ...IMMORTAL_POLE }
        ]
    },
    {
        name: "女帝の部屋",
        bonus: 500,
        map: [
            { posX: 3, posY: 0, ...LOLA },
            { posX: 4, posY: 7, ...LOLA },
            { posX: 3, posY: 4, ...ELVIRA },
            { posX: 4, posY: 3, ...ELVIRA },
            { posX: 0, posY: 1, ...TREASURE },
            { posX: 0, posY: 2, ...IMMORTAL_TOMB },
            { posX: 2, posY: 2, ...IMMORTAL_TOMB },
            { posX: 4, posY: 2, ...IMMORTAL_TOMB },
            { posX: 6, posY: 2, ...IMMORTAL_TOMB },
            { posX: 1, posY: 5, ...IMMORTAL_TOMB },
            { posX: 3, posY: 5, ...IMMORTAL_TOMB },
            { posX: 5, posY: 5, ...IMMORTAL_TOMB },
            { posX: 7, posY: 5, ...IMMORTAL_TOMB }
        ]
    },
    {
        name: "女教皇の大ホール",
        bonus: 600,
        map: [
            { posX: 3, posY: 0, ...LOLA },
            { posX: 4, posY: 0, ...LOLA },
            { posX: 0, posY: 2, ...RUDO },
            { posX: 7, posY: 2, ...RUDO },
            { posX: 0, posY: 5, ...RUDO },
            { posX: 7, posY: 5, ...RUDO },
            { posX: 3, posY: 6, ...RUDO },
            { posX: 5, posY: 6, ...TREASURE },
            { posX: 0, posY: 0, ...IMMORTAL_POLE },
            { posX: 7, posY: 0, ...IMMORTAL_POLE },
            { posX: 0, posY: 3, ...IMMORTAL_POLE },
            { posX: 7, posY: 3, ...IMMORTAL_POLE },
            { posX: 0, posY: 6, ...IMMORTAL_POLE },
            { posX: 7, posY: 6, ...IMMORTAL_POLE },
        ]
    },
    {
        name: "魔術師の礼拝堂",
        bonus: 1000,
        clear: SCENARIO_FINAL,
        map: [
            { posX: 6, posY: 0, ...LOLA },
            { posX: 0, posY: 2, ...ELVIRA },
            { posX: 1, posY: 2, ...RUDO },
            { posX: 0, posY: 5, ...RUDO },
            { posX: 7, posY: 5, ...ELVIRA },
            { posX: 2, posY: 7, ...SEOHYUN },
            { posX: 5, posY: 1, ...TREASURE },
            { posX: 0, posY: 0, ...IMMORTAL_TOMB },
            { posX: 7, posY: 0, ...IMMORTAL_TOMB },
            { posX: 2, posY: 2, ...IMMORTAL_POLE },
            { posX: 5, posY: 2, ...IMMORTAL_POLE },
            { posX: 2, posY: 5, ...IMMORTAL_POLE },
            { posX: 5, posY: 5, ...IMMORTAL_POLE },
        ]
    },
    {
        name: "魔女の神殿",
        bonus: 0,
        start: SCENARIO_WITCH,
        clear: SCENARIO_ENDING,
        subjugation: true,
        gimmick: GIMMICK_BEAST,
        map: [
            { posX: 3, posY: 2, ...GARM, gimmickNo: 0 },
            { posX: 4, posY: 2, ...ZILANT, target: true },
            { posX: 5, posY: 2, ...GRYPHON, gimmickNo: 1 },
            { posX: 4, posY: 3, ...NIGHTMARE, gimmickNo: 2 },
            { posX: 3, posY: 1, ...IMMORTAL_CLYSTAL },
            { posX: 4, posY: 1, ...IMMORTAL_CLYSTAL },
            { posX: 5, posY: 1, ...IMMORTAL_CLYSTAL },
            { posX: 0, posY: 0, ...IMMORTAL_CLYSTAL },
            { posX: 0, posY: 2, ...IMMORTAL_CLYSTAL },
            { posX: 0, posY: 4, ...IMMORTAL_CLYSTAL },
            { posX: 0, posY: 6, ...IMMORTAL_CLYSTAL },
            { posX: 1, posY: 7, ...IMMORTAL_CLYSTAL },
            { posX: 3, posY: 7, ...IMMORTAL_CLYSTAL },
            { posX: 5, posY: 7, ...IMMORTAL_CLYSTAL },
            { posX: 7, posY: 7, ...IMMORTAL_CLYSTAL }
        ]
    }
]

// =============================

export const getStageName = (arrivalStage) => {
    if (arrivalStage > stageDataArray.length) {
        return null;
    }
    return stageDataArray[arrivalStage].name;
}

export const getStageBonus = (arrivalStage) => {
    if (arrivalStage > stageDataArray.length) {
        return null;
    }
    return stageDataArray[arrivalStage].bonus;
}

/**
 * return
 * stageArray: [ {posX, posY, object, hp} ...]
 */
export const getStageData = (arrivalStage) => {
    if (arrivalStage > stageDataArray.length) {
        return null;
    }
    return stageDataArray[arrivalStage].map;
}

export const getClearStageScenario = (arrivalStage) => {
    if (arrivalStage > stageDataArray.length) {
        return null;
    }
    return stageDataArray[arrivalStage].clear;
}

export const getStartStageScenario = (stage) => {
    if (stage > stageDataArray.length) {
        return null;
    }
    return stageDataArray[stage].start;
}

export const isSubjugation = (stage) => {
    if (stage > stageDataArray.length) {
        return null;
    }
    return stageDataArray[stage].subjugation;
}

export const getStageGimmick = (stage) => {
    if (stage > stageDataArray.length) {
        return null;
    }
    return stageDataArray[stage].gimmick;
}

export const getTotalTreasure = () => {
    let count = 0;
    stageDataArray.forEach(data => {
        data.map.forEach(panel => {
            if (panel.object === object.OBJ_TREASURE) {
                count++;
            }
        })
    })
    return count;
}